<script setup lang="ts">
  import Button from '@leaflink/stash/Button.vue';

  import i18n from '@/plugins/i18n';

  import { useFeatureEnrollmentProvider } from './FeatureEnrollmentLayout.vue';
  import FeatureEnrollmentNavButton from './FeatureEnrollmentNavButton.vue';

  const {
    featureName,
    steps,
    footerRef,
    activeStepIndex,
    activeSubstepIndex,
    exitButtonText,
    nextButtonText,
    backButtonText,
    enrollButtonText,
    isProcessing,
    isEnrollmentComplete,
    isNavForwardDisabled,
    next,
    back,
    enroll,
    openExitDialog,
  } = useFeatureEnrollmentProvider();
</script>

<template>
  <footer
    class="tw-flex tw-flex-col tw-gap-6 tw-sticky tw-p-6 tw-bg-ice-100 tw-border-ice tw-border-t tw-bottom-0 md:tw-flex-row md:tw-items-center md:tw-justify-between"
    ref="footerRef"
  >
    <div>
      <p v-if="isEnrollmentComplete" class="tw-text-small tw-m-0">
        {{ i18n.t('common.completed') }}
      </p>

      <p v-else class="tw-text-small tw-m-0">Step {{ activeStepIndex + 1 }} of {{ steps.length }}</p>

      <p class="tw-font-bold tw-m-0">{{ featureName }}</p>
    </div>

    <div
      v-if="!isEnrollmentComplete"
      class="tw-flex tw-flex-col tw-gap-6 md:tw-flex-row [&>button]:tw-w-full [&>button]:md:tw-min-w-24 [&>button]:md:tw-w-auto"
    >
      <Button
        v-if="activeStepIndex === 0 && activeSubstepIndex === 0"
        secondary
        color="blue"
        data-test="footer|exit-button"
        :title="exitButtonText"
        @click="openExitDialog"
      >
        {{ exitButtonText }}
      </Button>

      <Button
        v-if="activeStepIndex > 0 || activeSubstepIndex > 0"
        secondary
        color="blue"
        :title="backButtonText"
        @click="back"
      >
        {{ backButtonText }}
      </Button>

      <FeatureEnrollmentNavButton
        v-if="activeStepIndex + 1 < steps.length"
        :title="nextButtonText"
        :loading="isProcessing"
        :disabled="isNavForwardDisabled"
        @click="next"
      >
        {{ nextButtonText }}
      </FeatureEnrollmentNavButton>

      <FeatureEnrollmentNavButton
        v-if="activeStepIndex + 1 === steps.length"
        class="tw-relative"
        :title="enrollButtonText"
        :loading="isProcessing"
        :disabled="isNavForwardDisabled"
        @click="enroll"
      >
        {{ enrollButtonText }}
      </FeatureEnrollmentNavButton>
    </div>
  </footer>
</template>
